'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Unicode regional indicators start at 0x1F1E6 (A) to 0x1F1FF (Z).
 * This value is the start minus the code point for uppercase letter A.
 *
 * Therefore, adding this number to an uppercase letter will
 * result in a regional indicator character.
 *
 * @see https://www.unicode.org/Public/UCD/latest/ucd/emoji/emoji-data.txt
 * @see http://unicode.org/reports/tr51/#def_emoji_flag_sequence
 */
var REGIONAL_INDICATOR_CHAR_CODE_OFFSET = 127397;
function charToRegionalIndicator(char) {
    return String.fromCodePoint(char.charCodeAt(0) + REGIONAL_INDICATOR_CHAR_CODE_OFFSET);
}
/**
 *  Transform (2 character) country code to regional indicator characters.
 *  Cast those to a string to form a flag.
 */
function countryCodeToFlag(code) {
    if (!code || code.length !== 2) {
        return '🏳';
    }
    return code.substr(0, 2).toUpperCase().replace(/./g, charToRegionalIndicator);
}

exports.default = countryCodeToFlag;
//# sourceMappingURL=flag.js.map
